let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lyb2f")).then(() => parcelRequire('icwjb'));